module.exports = __webpack_public_path__ + "static/media/Loader-xpdconnect.6b7db59c.gif";